export default function getUrlQueryParams(params: Record<string, any>): string {
  if (Object.keys(params).length === 0) {
    return ''
  }

  const query = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')
  return query ? `?${query}` : ''
}
